import {
  FETCH_SHIPPING,
  RESET_SHIPPING,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const shippingViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SHIPPING:
      return { data: action.payload };
    case RESET_SHIPPING:
      return initialState;
    default:
      return state;
  }
};

export default shippingViewReducer;
